import React from 'react'
import Layout from '../../layout/Layout'
import { Link, useLocation } from 'react-router-dom'
import { IconCalendarMonth, IconChartBar, IconHandClick } from '@tabler/icons-react';
import { formatDateToShortMonthDayYear } from '../../utils/dateTimeConverter';
import AnalysisGraph from '../../components/AnalysisComponents/AnalysisGraph';
import LocationTable from '../../components/AnalysisComponents/LocationTable';
import BrowserDonutChart from '../../components/AnalysisComponents/BrowserDonutChart';
import OsDonutChart from '../../components/AnalysisComponents/OsDonutChart';

const LinkDetails = () => {
    const { state } = useLocation();

    return (
        <Layout>
            <div className='flex gap-3 p-3 rounded-lg bg-white mb-3'>
                <div className="bg-[var(--primary-30)] p-1.5 rounded-full h-max">
                    <img src={state?.favicon} alt="" className='h-9 w-9 aspect-square object-cover' />
                </div>
                <div>
                    <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{state?.linkName}</p>
                    <Link to={state?.shortLink} target='_blank'> <p className="mb-0.5 font-semibold text-primary text-sm">{state?.shortLink}</p></Link>
                    <Link to={state?.mainLink} target='_blank'><p className="mb-0.5 text-xs italic text-[var(--black)] max-line-2">{state?.mainLink}</p></Link>
                    <div className="flex gap-2">
                        <p className={`font-semibold text-[10px] ${state?.linkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconChartBar size={16} /> </span> {state?.linkClicks ?? "0"} engagements</p>
                        <p className={`font-semibold text-[10px] ${state?.uniqueLinkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconHandClick size={16} /> </span> {state?.uniqueLinkClicks ?? "0"} unique clicks</p>
                        <p className="font-semibold text-[10px] text-[#BDBDBD] inline-flex items-center gap-1 mb-0"> <span> <IconCalendarMonth size={16} /> </span> {formatDateToShortMonthDayYear(state?.createdAt)}</p>
                    </div>
                </div>
            </div>
            <div className='mb-3'><AnalysisGraph linkId={state?.linkId} userId={state?.userId} organizationId={state?.organizationId} title={"Clicks"} subTitle={"Clicks"} /></div>
            <div className='mb-3'><LocationTable linkId={state?.linkId} userId={state?.userId} organizationId={state?.organizationId} title={"Clicks"} /></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="col-span-1">
                    <BrowserDonutChart linkId={state?.linkId} userId={state?.userId} organizationId={state?.organizationId} title={"Clicks"} />
                </div>
                <div className="col-span-1">
                    <OsDonutChart linkId={state?.linkId} userId={state?.userId} organizationId={state?.organizationId} title={"Clicks"} />
                </div>
            </div>
        </Layout>
    )
}

export default LinkDetails